export default {
  STATUS_202: 202,
  STATUS_401: 401,
  STATUS_404: 404,
  STATUS_409: 409,
  STATUS_429: 429,
};
